<div class="new-content" *ngIf="!pane else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="content">

    <app-filter-content [tabs]="filterTabs" [activeTab]="selectedTab" (onSelect)="onSelectItem($event)"></app-filter-content>

    <div class="content-cards">
      <div *ngFor="let lesson of content; let i = index; trackBy: trackContentByFn"
           class="card-wrap"
           (click)="onOpenCard(lesson)">
        <app-content-card-mini [item]="lesson"
                               [linkEnable]="false"
                               format="card-mini"
                               [infinity]="pane?.infinity">
        </app-content-card-mini>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>

    <ng-container *ngIf="!content.length && !pane.loading" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-empty [empty]="emptyObj"></app-empty>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)">
  <app-modal-body>
    <app-content-card class="modal"
                      [item_id]="item.id"
                      [show]="true"
                      [canClose]="false"
                      [inline]="false"
                      [active]="false"
                      [meta]="true"
                      (favoriteChanged)="onFavoriteChanged(item.id)">
    </app-content-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <div class="card">
      <app-content-card [item_id]="item.id"
                        [canClose]="false"
                        [inline]="false"
                        [active]="false"
                        [displayMode]="'content_page'"
                        [meta]="true"
                        (favoriteChanged)="onFavoriteChanged(item.id)">
      </app-content-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
